import React from "react";
import { FaMagnifyingGlass, FaPenRuler, FaCode, FaCircleCheck, FaRocket, FaArrowRight, FaLayerGroup } from "react-icons/fa6";
import { SiShopify, SiWoocommerce, SiMagento, SiNextdotjs, SiLaravel, SiWordpress } from "react-icons/si";
import { Container } from "../home/ui";

const steps = [
  { icon: FaMagnifyingGlass, title: "Discovery", text: "Understand your business, target audience, and goals.", num: "bg-[#1E88FF]", circle: "bg-[#E3F1FF] text-[#1E88FF]" },
  { icon: FaPenRuler, title: "Plan & Design", text: "Create wireframes and modern, conversion-focused designs.", num: "bg-[#6D5BF6]", circle: "bg-[#EFEAFF] text-[#7C3AED]" },
  { icon: FaCode, title: "Development", text: "Build with the latest technologies and best practices.", num: "bg-[#4F6BF6]", circle: "bg-[#E8EEFF] text-[#3D5BF6]" },
  { icon: FaCircleCheck, title: "Testing", text: "Ensure quality, security, and smooth performance across devices.", num: "bg-[#1E88FF]", circle: "bg-[#E3F1FF] text-[#1E88FF]" },
  { icon: FaRocket, title: "Launch & Support", text: "Deploy and provide ongoing support and improvements.", num: "bg-[#8B2CF5]", circle: "bg-[#F1E8FF] text-[#8B2CF5]" },
];

const platforms = [
  { icon: SiShopify, label: "Shopify", cls: "text-[#7AB55C]" },
  { icon: SiWoocommerce, label: "WooCommerce", cls: "text-[#7F54B3] !text-[72px] -my-[13px]" },
  { icon: SiMagento, label: "Magento", cls: "text-[#EE672F]" },
  { icon: SiNextdotjs, label: "Next.js", cls: "text-black" },
  { icon: SiLaravel, label: "Laravel", cls: "text-[#FF2D20]" },
  { icon: SiWordpress, label: "WordPress", cls: "text-[#21759B]" },
  { icon: FaLayerGroup, label: "Custom Solutions", cls: "text-[#5B6CF6]" },
];

const EcomProcessTech = () => (
  <section className="bg-gradient-to-b from-white to-[#FAFBFF] py-[40px] lg:py-[56px]">
    <Container className="max-w-[1320px]">
      <h2 className="text-[28px] font-bold leading-[1.2] tracking-tight text-[#0B0D2C] sm:text-[34px] xl:text-[38px]">
        Our E-commerce Development Process
      </h2>
      <p className="mt-[8px] text-[15px] text-slate-600 sm:text-[16px]">
        A transparent and collaborative process to deliver a high-performing online store.
      </p>

      <div className="mt-[30px] grid gap-[28px] sm:grid-cols-2 lg:grid-cols-5 lg:gap-[16px]">
        {steps.map((s, i) => (
          <div key={s.title} className="relative">
            {i < steps.length - 1 && (
              <FaArrowRight className="absolute right-[10%] top-[34px] hidden text-[16px] text-[#A9B6E8] lg:block" aria-hidden="true" />
            )}
            <div className="relative ml-[24px] inline-flex">
              <span className={`inline-flex h-[70px] w-[70px] items-center justify-center rounded-full text-[28px] ${s.circle}`}>
                <s.icon />
              </span>
              <span
                className={`absolute -left-[22px] -top-[8px] inline-flex h-[30px] w-[30px] items-center justify-center rounded-full text-[12px] font-semibold text-white ring-[3px] ring-white ${s.num}`}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <h3 className="mt-[14px] text-[15.5px] font-semibold text-[#0B0D2C]">{s.title}</h3>
            <p className="mt-[6px] max-w-[190px] text-[13.5px] leading-[1.55] text-slate-500">{s.text}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-[56px] text-[28px] font-bold leading-[1.2] tracking-tight text-[#0B0D2C] sm:text-[34px] xl:text-[38px]">
        Technologies We Work With
      </h2>
      <p className="mt-[8px] text-[15px] text-slate-600 sm:text-[16px]">
        We build e-commerce websites using modern and trusted platforms.
      </p>
      <div className="mt-[28px] grid grid-cols-3 gap-y-[28px] sm:grid-cols-4 lg:grid-cols-7">
        {platforms.map((p) => (
          <div key={p.label} className="flex flex-col items-center gap-[12px] text-center">
            <p.icon className={`text-[46px] ${p.cls}`} />
            <span className="text-[14px] text-[#1F2547]">{p.label}</span>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default EcomProcessTech;
